export function parseDeviceList(deviceBtFriendlyNames: string): string[] {
  return [
    ...new Set(
      deviceBtFriendlyNames
        .split(';')
        .map(name => name.trim())
        .filter(name => name.length > 0)
    )
  ];
}

export function isReadonlyWhitelistStatus(status: string): boolean {
  return status === 'Active' || status === 'Inactive';
}

export function getAvailablePercentages(
  groupId: number,
  rolloutPercentages: number[],
  isEditing: boolean,
  rolloutStatus: string,
  initialPercentages: Record<number, number | undefined>
): number[] {
  if (!isEditing) {
    return rolloutPercentages;
  }

  const initialPercentage = initialPercentages[groupId] ?? 0;

  if (rolloutStatus === 'Draft') {
    return rolloutPercentages;
  }

  if (rolloutStatus === 'Active' || rolloutStatus === 'Inactive') {
    return rolloutPercentages.filter(percentage => percentage >= initialPercentage);
  }

  return rolloutPercentages;
}
